import { ApiClient } from './client';
import { ensureGuestToken } from './token-manager';
import { publicEndpoints } from '@/lib/endpoints';

const PUBLIC_BASE_URL = 'https://' + import.meta.env.VITE_BACKEND_CUSTOM_DOMAIN_NAME + '/api-frontend/';

const client = new ApiClient(PUBLIC_BASE_URL);

export const publicApi = {
  get: async <T>(endpoint: string) => {
    await ensureGuestToken();
    return client.get<T>(endpoint);
  },
  post: async <T>(endpoint: string, data?: unknown) => {
    // Don't call ensureGuestToken for login requests to avoid interference
    if (endpoint === publicEndpoints.auth.login && data && typeof data === 'object' && 'is_guest' in data && !data.is_guest)
      return client.post<T>(endpoint, data);
    await ensureGuestToken();
    return client.post<T>(endpoint, data);
  },
  put: async <T>(endpoint: string, data?: unknown) => {
    await ensureGuestToken();
    return client.put<T>(endpoint, data);
  },
  patch: async <T>(endpoint: string, data?: unknown) => {
    await ensureGuestToken();
    return client.patch<T>(endpoint, data);
  },
  delete: async <T>(endpoint: string) => {
    await ensureGuestToken();
    return client.delete<T>(endpoint);
  },
  /**
   * POST a raw binary body (e.g. a File/Blob) to `endpoint`.
   * Handles guest-token refresh and auth header injection via the shared ApiClient.
   */
  postBinary: async <T>(endpoint: string, body: BodyInit, contentType: string) => {
    await ensureGuestToken();
    return client.postRaw<T>(endpoint, body, contentType);
  },
  postForm: async <T>(endpoint: string, body: FormData) => {
    await ensureGuestToken();
    return client.postForm<T>(endpoint, body);
  },
};